import { API_ENDPOINT } from './config';

const CMS_BASE = '/cms';

export const urlsStudyPrograms = {
  // Study programs & filters
  studyPrograms: `${API_ENDPOINT}/study-programs`,
  studyProgramTypes: `${API_ENDPOINT}/study-program-types`,
  studyProgramsIng: `${API_ENDPOINT}/study-programs?ing=true`,
  studyProgramsIngState: `${API_ENDPOINT}/study-programs?state=true`,
  studyProgramsIngAll: `${API_ENDPOINT}/study-programs?ing-all=true`,
  studyProgramsBcIngAll: `${API_ENDPOINT}/study-programs?bc-ing-all=true`,
  studyProgramsPhdAll: `${API_ENDPOINT}/study-programs?phd-all=true`,

  // Subjects
  studySubjectsWs: `${API_ENDPOINT}/study-subjects-ws`,
  studySubjects: `${API_ENDPOINT}/study-subjects`,
};

export const routesStudyPrograms = {
  cmsStudyPrograms: `${CMS_BASE}/study-programs`,
  cmsStudyProgramsCreate: `${CMS_BASE}/study-programs/create`,
  cmsStudyProgramsEdit: `${CMS_BASE}/study-programs/edit`,
};
